// extracted by css-extract-rspack-plugin
export default {"root":"nw0hq5"};